import { FC } from 'react';
import { Theme, useMediaQuery, useTheme, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HeaderMenu, IAccountMenu, IMenuItem } from '../HeaderMenu';
import { TopBarHeaderMenu } from './TopBarHeaderMenu';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        [theme.breakpoints.down('md')]: {
            marginTop: 64,
            marginLeft: 0,
        },
    },
}));

interface ITransitionalHeaderMenuProps {
    menuItems: IMenuItem[];
    accountMenu: IAccountMenu;
}

export const TransitionalHeaderMenu: FC<ITransitionalHeaderMenuProps> = ({ menuItems, accountMenu, children }) => {
    const drawerWidth = 280;

    const classes = useStyles();
    const theme = useTheme();
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {isMdDown && <HeaderMenu menuItems={menuItems} accountMenu={accountMenu} drawerWidth={drawerWidth} />}
            {!isMdDown && <TopBarHeaderMenu menuItems={menuItems} accountMenu={accountMenu} />}
            <Box
                className={classes.root}
                sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', width: '100%' }}
            >
                {children}
            </Box>
        </Box>
    );
};
